import TaxReportPresenter from "@adapters/presenters/Reports/CoreReportsRevamp/TaxRevamp";
export default (useCases, actions) => {
    return {
        taxReport: new TaxReportPresenter(useCases.taxReport, actions),
    };
};
